export default process.env.NODE_ENV === "production"
  ? "https://analytics.verdedata.ro"
  : "http://localhost:3333";
// export default process.env.NODE_ENV === 'production' ? 'https://test.analytics.verdedata.ro' : 'http://localhost:3805'
// export default process.env.NODE_ENV === 'production' ? 'http://10.194.250.173' : 'https://analytics.test'
// export default process.env.NODE_ENV === 'production' ? 'https://analytics.test' : 'https://analytics.test'
